import React, { useCallback } from 'react';

import { Box, Menu } from '@mui/material';
import { useCurrentAddMenuAnchorElement, useInvokeAddBlock } from '@wp-block-builder/stores/AddBlockMenuStore';

import Avatar from '../blocks/Avatar';
import Button from '../blocks/Button';
import ColumnsSection from '../blocks/ColumnsSection';
import Container from '../blocks/Container';
import Divider from '../blocks/Divider';
import Heading from '../blocks/Heading';
import { type TBlockButton } from '../blocks/helpers/defineBlockButton';
import Html from '../blocks/Html';
import Image from '../blocks/Image';
import LoopContainer from '../blocks/LoopContainer';
import ProgressBar from '../blocks/ProgressBar';
import Spacer from '../blocks/Spacer';
import Text from '../blocks/Text';

import BlockTypeButton from './BlockTypeButton';

export default function SelectBlockTypeMenu() {
  const [anchorEl, setAnchorEl] = useCurrentAddMenuAnchorElement();
  const addBlock = useInvokeAddBlock();
  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const onClick = useCallback(
    (block: TBlockButton) => {
      addBlock(block);
      onClose();
    },
    [addBlock, onClose]
  );

  if (anchorEl === null) {
    return null;
  }

  return (
    <Menu
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Box sx={{ p: 1, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
        <BlockTypeButton button={Heading} onClick={onClick} />
        <BlockTypeButton button={Text} onClick={onClick} />
        <BlockTypeButton button={Button} onClick={onClick} />
        <BlockTypeButton button={Image} onClick={onClick} />
        <BlockTypeButton button={Avatar} onClick={onClick} />
        <BlockTypeButton button={Divider} onClick={onClick} />
        <BlockTypeButton button={Spacer} onClick={onClick} />
        <BlockTypeButton button={ProgressBar} onClick={onClick} />
        <BlockTypeButton button={Html} onClick={onClick} />
        <BlockTypeButton button={ColumnsSection} onClick={onClick} />
        <BlockTypeButton button={Container} onClick={onClick} />
        <BlockTypeButton button={LoopContainer} onClick={onClick} />
      </Box>
    </Menu>
  );
}
